/**Recibo para reclamo */
export class ComplaintBill {
    /**Número de recibo */
    public number: string;
    /**Periodo */
    public period?: string;
    /**Moneda */
    public currency: string;
    /**Monto total */
    public totalAmount: string;
    /**Lista de items */
    public itemList?: string[];
}